<!--
Material Design SVG Icons

Easily add and style any icons from the MDI library.

1. Install the icon paths.

   npm i @mdi/js


2. Import the path you want to use AND the Icon component

   import { mdiAccountCircle } from '@mdi/js';
   import Icon from 'components';


3. Use with supplied path property like this:

  <Icon path={mdiAccountCircle}/>


# NOTES

** Find icon names here: https://materialdesignicons.com/ **

- As with all nested Svelte components, there's currently no good way to define classes in a
parent component because the "unused" class in the parent will be tree-shaken.

- You can add inline styles including `fill` and `width` to override color and size.

  <Icon path={mdiAccountCircle} style="fill: red; width: 4rem;"/>


-->
<script>
  export let path;
  export let style = '';
</script>

<svg style="{style}" width="24px" height="24px" viewBox="0 0 24 24" fill="currentColor">
  <path d="{path}"></path>
</svg>
